import { cva, VariantProps } from 'class-variance-authority';

import { BonusIconLight } from '../../components/bonus/bonus-icon-light';
import { Typography } from '../../components/typography/typography';
import { Skeleton } from '../../lib/shadcn/components/ui/skeleton';
import { Stack } from '../../lib/shadcn/components/ui/stack/stack';
import { cn } from '../../lib/shadcn/lib/utils';

type BonusChipProps = {
  bonuses: number;
  prefix?: string;
  size?: 'md' | 'sm';
  isLoading?: boolean;
  className?: string;
  dataTestId?: string;
};

const chipVariants = cva('w-fit rounded-small bg-accent-500 p-unit-1', {
  variants: {
    size: {
      md: 'pl-unit-3',
      sm: 'pl-unit-2',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export function BonusChip({
  bonuses,
  prefix = '',
  size = 'md',
  isLoading = false,
  className,
  dataTestId,
}: BonusChipProps & VariantProps<typeof chipVariants>) {
  if (isLoading) {
    return (
      <Skeleton className={cn('h-[20px] w-[40px] rounded-xl bg-accent-500', className)} />
    );
  }

  const TextTypography = size === 'md' ? Typography.p4 : Typography.small1;

  return (
    <Stack
      align="center"
      justify="center"
      direction="row"
      gap={1}
      className={cn(chipVariants({ size }), className)}
      data-testid={dataTestId}
    >
      <TextTypography data-testid="bonus-chip" className="text-white">
        {prefix} {Math.trunc(bonuses)}
      </TextTypography>
      <BonusIconLight
        className={cn({ 'size-[16px]': size === 'md', 'size-[14px]': size === 'sm' })}
      />
    </Stack>
  );
}
